import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import "@/App.css";

import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { BookingProvider } from "@/context/BookingContext";
import { SiteMediaProvider } from "@/context/SiteMediaContext";
import SiteMedia from "./pages/admin/SiteMedia";

import { Header } from "./components/public/Header";
import { Footer } from "./components/public/Footer";
import { FloatingButtons } from "./components/public/FloatingButtons";
import { BookingModal } from "./components/public/BookingModal";
import { ProtectedRoute } from "./components/admin/ProtectedRoute";

import Home from "./pages/public/Home";
import About from "./pages/public/About";
import Treatments from "./pages/public/Treatments";
import Pricing from "./pages/public/Pricing";
import Results from "./pages/public/Results";
import Contact from "./pages/public/Contact";
import Blog from "./pages/public/Blog";
import BlogPost from "./pages/public/BlogPost";

import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Clients from "./pages/admin/Clients";
import ClientDetail from "./pages/admin/ClientDetail";
import Agenda from "./pages/admin/Agenda";
import Availability from "./pages/admin/Availability";
import Services from "./pages/admin/Services";
import Campaigns from "./pages/admin/Campaigns";
import BlogAdmin from "./pages/admin/Blog";
import Testimonials from "./pages/admin/Testimonials";
import BeforeAfter from "./pages/admin/BeforeAfter";
import Payments from "./pages/admin/Payments";
import Team from "./pages/admin/Team";
import ChangePassword from "./pages/admin/ChangePassword";
import SettingsPage from "./pages/admin/Settings";
import ManageAppointment from "./pages/public/ManageAppointment";

const PublicLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
    <FloatingButtons />
    <BookingModal />
  </>
);

function App() {
  return (
    <div className="App">
      <SiteMediaProvider>
      <LanguageProvider>
        <AuthProvider>
          <BookingProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/sobre" element={<About />} />
                  <Route path="/tratamentos" element={<Treatments />} />
                  <Route path="/precos" element={<Pricing />} />
                  <Route path="/resultados" element={<Results />} />
                  <Route path="/contato" element={<Contact />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/rdv/:token" element={<ManageAppointment />} />
                </Route>

                <Route path="/admin/login" element={<Login />} />
                <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/admin/clientes" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
                <Route path="/admin/clientes/:id" element={<ProtectedRoute><ClientDetail /></ProtectedRoute>} />
                <Route path="/admin/agenda" element={<ProtectedRoute><Agenda /></ProtectedRoute>} />
                <Route path="/admin/disponibilidade" element={<ProtectedRoute><Availability /></ProtectedRoute>} />
                <Route path="/admin/servicos" element={<ProtectedRoute><Services /></ProtectedRoute>} />
                <Route path="/admin/campanhas" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
                <Route path="/admin/blog" element={<ProtectedRoute><BlogAdmin /></ProtectedRoute>} />
                <Route path="/admin/depoimentos" element={<ProtectedRoute><Testimonials /></ProtectedRoute>} />
                <Route path="/admin/resultados" element={<ProtectedRoute><BeforeAfter /></ProtectedRoute>} />
                <Route path="/admin/pagamentos" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
                <Route path="/admin/equipe" element={<ProtectedRoute><Team /></ProtectedRoute>} />
                <Route path="/admin/midia" element={<ProtectedRoute><SiteMedia /></ProtectedRoute>} />
                <Route path="/admin/configuracoes" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
                <Route path="/admin/senha" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-right" />
          </BookingProvider>
        </AuthProvider>
      </LanguageProvider>
      </SiteMediaProvider>
    </div>
  );
}

export default App;
